import { render, staticRenderFns } from "./ScaniaBar.vue?vue&type=template&id=2fcf218b&"
import script from "./ScaniaBar.vue?vue&type=script&lang=js&"
export * from "./ScaniaBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports